import { Grid } from "@mui/material";
import React, { useState } from "react";
import FilterSection from "./FilterSection";
import TableSection from "./TableSection";

const CdMainSection = () => {
  const [showFilters, setShowFilters] = useState(true);
  const [activeVendorTab, setActiveVendorTab] = useState("APPROVED");

  return (
    <Grid
      sx={{
        // backgroundColor: "#F4F4F4",
        display: "flex",
        height: "100%",
        // overflow: "auto",
        padding: "10px 0px 10px 10px",
        gap: "10px",
      }}
    >
      {/* First Section (Fixed Width) */}
      {showFilters && (
        <Grid>
          <FilterSection
            activeTab={activeVendorTab}
            onClose={() => setShowFilters(false)}
          />
        </Grid>
      )}

      {/* Second Section (Auto Width) */}
      <div
        className="min-h-0 flex-grow overflow-x-auto overflow-y-auto pr-2"
      >
        <TableSection
          isFilterPanelOpen={showFilters}
          onToggleFilters={() => setShowFilters((prev) => !prev)}
          onActiveTabChange={setActiveVendorTab}
        />
      </div>
    </Grid>
  );
};

export default CdMainSection;
